module.exports = __webpack_public_path__ + "static/media/11NEPAD6.d827db2a.jpg";